<template>
    <div class="page-course-detail">
        <ContentLoader :isDisplay="!contentReady" />
        <template v-if="contentReady">
            <vue-headful :title="fields.detail.moduleTitle + ' - ProbPlus'" :description="fields.detail.longDesc" />
            <section class="top-title" :style="{ backgroundImage: 'url(' + require('@/assets/module-' + fields.detail.moduleNumber + '/module-bg.jpg') + ')' }">
                <div class="container">
                    <h2>MODULE {{ fields.detail.moduleNumber }}</h2>
                </div>
            </section>
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><router-link :to="'/' + $route.params.lang"><font-awesome-icon :icon="['fas', 'home']" /></router-link></li>
                        <li class="breadcrumb-item"><router-link :to="'/' + $route.params.lang + '/course'">{{ $PPlusEngine.getDictionary($route.params.lang, 'บทเรียนทั้งหมด', 'All Modules') }}</router-link></li>
                        <li class="breadcrumb-item active" aria-current="page">Module {{ fields.detail.moduleNumber }}</li>
                    </ol>
                </nav>
                <div class="row">
                    <div class="col-md-12 col-lg-8">
                        <section class="objective">
                            <div class="global-box-content">
                                <div class="title">
                                    <h1>{{ fields.detail.moduleTitle }}</h1>
                                    <p>{{ $PPlusEngine.getDictionary($route.params.lang, 'จำนวน: ', 'Total: ') }} {{ fields.chapter.length }} {{ $PPlusEngine.getDictionary($route.params.lang, 'บท', 'Chapter(s)') }}</p>
                                    <button v-for="(item, index) in fields.chapter" :key="index" @click="validatePaid('/' + $route.params.lang + '/course/' + item.moduleNumber + '/' + item.chapterNumber)">
                                        <font-awesome-icon :icon="['fas', 'caret-right']" />{{ item.chapterTitle }}
                                    </button>
                                </div>
                                <div class="desc">
                                    {{ fields.detail.longDesc }}
                                </div>
                                <h2>{{ $PPlusEngine.getDictionary($route.params.lang, 'คุณจะได้เรียนรู้อะไรบ้าง', 'What You’ll Learn') }}</h2>
                                <div class="item" v-for="(item, index) in fields.detail.objective" :key="index">
                                    <font-awesome-icon :icon="['fas', 'caret-right']" />
                                    <span>{{ item.description }}</span>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="col-md-12 col-lg-4">
                        <div class="chapter-title">{{ $PPlusEngine.getDictionary($route.params.lang, 'รายการ Chapter ทั้งหมด', 'Chapter List') }}</div>
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-12" v-for="(item, index) in fields.chapter" :key="index">
                                <ChapterBox :fields="item" />
                            </div>
                        </div>
                    </div>
                </div>
                <section class="other">
                    <h3>{{ $PPlusEngine.getDictionary($route.params.lang, 'Module อื่นๆ', 'Other Module') }}</h3>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-4" :class="{ 'd-none d-md-block': index > 1 }" v-for="(item, index) in fields.other" :key="index">
                            <CourseBox :fields="item" />
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import ChapterBox from '@/components/ChapterBox';
import CourseBox from '@/components/CourseBox';
import ValidateChapter from '@/resources/ValidateChapter';

export default {
    mixins: [ValidateChapter],
    components: {
        ContentLoader,
        ChapterBox,
        CourseBox
    },
    data() {
        return {
            contentReady: false,
            fields: {}
        }
    },
    created() {
        let page = this;
        let params = this.$route.params;
        
        setTimeout(function(){
            page.getContent(params);
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent(params) {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                courseNo: params.detail,
                langCode: this.$route.params.lang
            };

            this.$WeHelper.postAPI(apiURL, '/api/course/get-course-detail', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                this.fields = response.data;
                this.contentReady = true;
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-course-detail {
    padding-bottom: 40px;

    .top-title {
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        display: flex;
        align-items: center;
        width: 100%;
        height: 140px;
        margin-bottom: 40px;

        h2 {
            margin: 0;
            font-size: 36px;
            font-weight: 200;
            color: #fff;
            text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
            
            @media only screen and (max-width: $screenSmall) {
                font-size: 24px;
            }
        }
    }

    .objective {
        .title {
            h1 {
                font-size: 24px;
                color: $mainColor;
                margin: 0;
                padding-bottom: 20px;

                &:after {
                    content: " ";
                    display: block;
                    width: 100px;
                    height: 1px;
                    background: #ccc;
                    margin-top: 15px;
                }
            }

            p {
                font-size: 14px;
                line-height: 26px;
                color: #333;
                margin: 0;
                padding-bottom: 10px;
            }

            button {
                display: block;
                width: 100%;
                text-align: left;
                background: none;
                border: none;
                outline: none;
                font-size: 14px;
                color: #a26868;
                padding-bottom: 5px;

                &:hover {
                    color: $mainColor;
                    text-decoration: underline;
                }

                svg {
                    margin-right: 15px;
                    color: #ddd;
                }
            }
        }

        h2 {
            font-size: 22px;
            font-weight: 200;
            color: $mainColor;
            margin: 0;
            padding-bottom: 20px;

            &:after {
                content: " ";
                display: block;
                width: 100px;
                height: 1px;
                background: #ccc;
                margin-top: 15px;
            }
        }

        .desc {
            font-size: 14px;
            line-height: 26px;
            color: #000;
            padding: 15px 0 25px;
        }

        .item {
            padding: 7px 0;

            svg {
                color: #eae0d7;
                margin-right: 15px;
            }

            span {
                font-size: 14px;
                color: #000;
            }
        }
    }

    .chapter-title {
        background: #fff;
        padding: 7px 10px 7px 20px;
        border-left: 3px solid #ef8588;
        font-size: 14px;
        color: #555;
        margin-bottom: 20px;

        @media only screen and (max-width: $screenMedium) {
            margin-top: 20px;
        }
    }

    .other {
        padding-top: 40px;

        h3 {
            font-size: 24px;
            font-weight: 200;
            margin: 0;
            color: #666;
            padding-bottom: 10px;
            border-bottom: 1px solid #ddd;
        }
    }
}
</style>